import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { InvestmentSchemaDto } from './investment-schema-dto.model';


export class InvestmentDetailDto implements IInvestmentDetailDto {
    id!: number | undefined;
    financialYear!: string | undefined;
    employee!: EmployeeSummaryDto;
    investmentSchema!: InvestmentSchemaDto;
    investmentAmount!: number;
    investmentDate!: Date;
    underSectionId!: number | undefined;
    underSectionGroupId!: number | undefined;
    ispaid!: boolean;

    constructor(data?: IInvestmentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financialYear = _data["financialYear"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.investmentSchema = _data["investmentSchema"] ? InvestmentSchemaDto.fromJS(_data["investmentSchema"]) : <any>undefined;
            this.investmentAmount = _data["investmentAmount"];
            this.investmentDate = _data["investmentDate"] ? new Date(_data["investmentDate"].toString()) : <any>undefined;
            this.underSectionId = _data["underSectionId"];
            this.underSectionGroupId = _data["underSectionGroupId"];
            this.ispaid = _data["ispaid"];
        }
    }

    static fromJS(data: any): InvestmentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financialYear"] = this.financialYear;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["investmentSchema"] = this.investmentSchema ? this.investmentSchema.toJSON() : <any>undefined;
        data["investmentAmount"] = this.investmentAmount;
        data["investmentDate"] = this.investmentDate ? this.investmentDate.toISOString() : <any>undefined;
        data["underSectionId"] = this.underSectionId;
        data["underSectionGroupId"] = this.underSectionGroupId;
        data["ispaid"] = this.ispaid;
        return data; 
    }
}

export interface IInvestmentDetailDto {
    id: number | undefined;
    financialYear: string | undefined;
    employee: EmployeeSummaryDto;
    investmentSchema: InvestmentSchemaDto;
    investmentAmount: number;
    investmentDate: Date;
    underSectionId: number | undefined;
    underSectionGroupId: number | undefined;
    ispaid: boolean;
}

